import { API } from 'aws-amplify';
import { SSA_PREFERENCES_FILTER_PRESETS_URL_APPEND } from 'constants';

export const getFilterPresets = async () => {
  const filterPresets = await API.get(
    'delta-api',
    `${SSA_PREFERENCES_FILTER_PRESETS_URL_APPEND}`
  );
  return filterPresets;
};

export const getFilterPreset = async (presetName) => {
  const filterPreset = await API.get(
    'delta-api',
    `${SSA_PREFERENCES_FILTER_PRESETS_URL_APPEND}${presetName}`
  );
  return filterPreset;
};

export const postFilterPreset = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${SSA_PREFERENCES_FILTER_PRESETS_URL_APPEND}`,
    myPayload
  );
};

export const putFilterPreset = async (payload, presetName) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${SSA_PREFERENCES_FILTER_PRESETS_URL_APPEND}${presetName}`,
    myPayload
  );
};

export const deleteFilterPreset = async (presetName) => {
  await API.del(
    'delta-api',
    `${SSA_PREFERENCES_FILTER_PRESETS_URL_APPEND}${presetName}`
  );
};
